"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardItem = BoardItem;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_dom_1 = require("react-dom");
const react_jss_1 = require("react-jss");
const context_1 = require("../context");
const PieceDragContext_1 = require("../drag/PieceDragContext");
const TILE_BASE_Z_INDEX = 50;
const PREVIEW_SCALE = 1;
/** Prevent the default drag behavior for an element. */
const preventDrag = (e) => e.preventDefault();
const useStyles = (0, react_jss_1.createUseStyles)({
    boardItem: {
        position: "absolute",
        transition: "all 0.2s cubic-bezier(0.65, 0.05, 0.36, 1) 0s",
    },
    draggable: {
        touchAction: "none",
        cursor: "grab",
        userSelect: "none",
        WebkitUserDrag: "none",
    },
    hidden: {
        opacity: 0,
        transition: "none",
    },
    preview: {
        position: "fixed",
        pointerEvents: "none",
        zIndex: 9999,
        opacity: 0.85,
    },
});
function BoardItem({ id, x, y, draggable, children }) {
    const styles = useStyles();
    const { width, height } = (0, context_1.useBoardState)();
    const dragHandlers = (0, PieceDragContext_1.useDragPiece)(id);
    const activeDrag = (0, PieceDragContext_1.useActiveDrag)();
    const isDragging = (activeDrag === null || activeDrag === void 0 ? void 0 : activeDrag.id) === id;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", Object.assign({ className: (0, classnames_1.default)(styles.boardItem, {
                [styles.draggable]: draggable,
                [styles.hidden]: isDragging,
            }), style: {
                left: `${(x / width) * 100}%`,
                top: `${(y / height) * 100}%`,
                width: `${(1 / width) * 100}%`,
                height: `${(1 / height) * 100}%`,
                zIndex: TILE_BASE_Z_INDEX + y + 1,
            }, draggable: false, onDragStart: preventDrag }, (draggable ? dragHandlers : {})), children),
        isDragging &&
            (0, react_dom_1.createPortal)(react_1.default.createElement("div", { className: styles.preview, style: {
                    left: activeDrag.clientX - activeDrag.offsetX * PREVIEW_SCALE,
                    top: activeDrag.clientY - activeDrag.offsetY * PREVIEW_SCALE,
                    width: activeDrag.width * PREVIEW_SCALE,
                    height: activeDrag.height * PREVIEW_SCALE,
                } }, children), document.body)));
}
